<app-banner [heading]="'BOARD RESULTS'" [detail]="'ACHIEVING HIGH STANDARDS'"></app-banner>

<main id="main">

  <!-- ======= About Section ======= -->
  <section id="about" class="about">

    <div class="container">
      <div class="row">

        <div class="col-lg-6 col-md-6">
          <div class="about-img">
            <!-- ::before -->
            <img src="assets/img/achievers/Topper.png" alt="best school in kurukshetra">
            <!-- ::after -->
          </div>
        </div>

        <!-- <div class="col-lg-6 col-md-6">
          <div class="about-img">
            <img src="assets/img/achievers/shivam.png" alt="Shivam">
          </div>
        </div> -->

      </div>
    </div>
  </section><!-- End About Section -->

</main>